import { ArrowForward, Close } from '@mui/icons-material';
import {
    FlatList,
    ScrollView,
    StyleSheet,
    TouchableOpacity,
    View
} from 'react-native';
import Colors from '../../config/Colors';
import Text from '../../react-component/textComponent';

const styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.white,
        position: 'absolute',
        right: 8,
        top: 48,
        borderRadius: 6,
        borderWidth: 1,
        borderColor: '#00000029',
        maxHeight: 198,
        zIndex: 999
    },
    titleContainer: {
        padding: 16,
        flexDirection: 'row',
        justifyContent: 'space-between',
        maxWidth: 400
    },
    button: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: 16,
        backgroundColor: Colors.secondary,
        marginHorizontal: 8,
        marginBottom: 8,
        borderRadius: 6
    }
});

function PedidoUsuario({
    pedidosUsuario,
    usuario,
    toHours,
    handler,
    hideItems,
    handlerHidePedidos,
    selectPedido
}) {
    if (pedidosUsuario.length && !hideItems) {
        return (
            <View style={styles.container}>
                <View style={styles.titleContainer}>
                    <Text>
                        O cliente <Text $bold>{usuario}</Text> possui{' '}
                        {pedidosUsuario.length > 1
                            ? `outros ${pedidosUsuario.length} pedidos pendentes`
                            : 'outro pedido pendente'}{' '}
                        neste mesmo endereço:
                    </Text>

                    <TouchableOpacity
                        onPress={handlerHidePedidos}
                        hitSlop={{
                            top: 16,
                            bottom: 16,
                            left: 16,
                            right: 16
                        }}
                        style={{
                            marginLeft: 16
                        }}
                    >
                        <Close 
                          sx={{
                            fontSize: 24,
                          }} 
                        />
                    </TouchableOpacity>
                </View>

                <ScrollView>
                    <FlatList
                        data={pedidosUsuario}
                        renderItem={({ item }) => (
                            <TouchableOpacity
                                onPress={() => {
                                    selectPedido(item);

                                    handler(item.idPedido);
                                }}
                                style={styles.button}
                            >
                                <Text
                                    style={{
                                        fontFamily: 'NunitoSans-Regular',
                                        color: Colors.white
                                    }}
                                >
                                    <Text $bold>#{item.idPedido}</Text> (
                                    {item.idTipoEntregaRetirada === 1
                                        ? 'retirada'
                                        : 'entrega'}
                                    : {toHours(item.dhEntregaRetirada)})
                                </Text>

                                <ArrowForward
                                    sx={{
                                        fontSize: 24,
                                        color: Colors.white
                                    }}
                                />
                            </TouchableOpacity>
                        )}
                        keyExtractor={({ index }) => index}
                    />
                </ScrollView>
            </View>
        );
    }

    return <View />;
}

export default PedidoUsuario;
